module.exports = __webpack_public_path__ + "static/media/stars-less-1536.9a953b7c.webp";